import { defineMessages } from 'react-intl';

export default defineMessages({
  group: 'Group',
  emptyGroup: 'Empty group',
  loading: 'Loading surveys...',
});
